var exports = {
  "Js": "issueMetadata__GqBaGb",
  "yu": "metadata__TPDi2M",
  "Op": "metadataTitle__KCY0Bo",
  "TP": "metadataValue__fYoY3y",
  "ln": "stickyHeader__YJMGaN",
};

module.exports = exports;
